import { https , httpsFile } from './http.js';

export function index () {
    return https().get('material-group5');
}

export function getMatGrp5 (search,offset) {
    return https().get(`getMatGrp5?search=${search}&offset=${offset}`);
}